import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stattionList: [],
  allStatationList: [],
};

export const stationsSlice = createSlice({
  name: "stations",
  initialState,
  reducers: {
    setStationList: (state, action) => {
      state.stattionList = action.payload;
    },
    setAllStationList: (state, action) => {
      state.allStatationList = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setStationList, setAllStationList } = stationsSlice.actions;

export default stationsSlice.reducer;
